import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';

import { fieldNames } from '../../constants';
import { useAdminInfoFieldTypesQuery } from '../../queries/useAdminInfoFieldTypesQuery';
import showErrorMessage from '../../../../../../helpers/showErrorMessage';

export const AdminInfoCreateFieldForm = ({ form }) => {
  const { getFieldDecorator, setFieldsValue } = form;
  getFieldDecorator(fieldNames.type, { initialValue: null });

  const fieldTypesQuery = useAdminInfoFieldTypesQuery({
    onError: (error) => {
      showErrorMessage(error, 'Произошла ошибка при получении типов полей');
    },
  });

  const onFieldTypeChange = (fTypeId) => {
    const fTypeData = fieldTypesQuery.data.find(
      (fType) => fType.id === fTypeId
    );
    setFieldsValue({
      [fieldNames.type]: fTypeData,
    });
  };

  return (
    <Form>
      <Form.Item label="Тип поля">
        {getFieldDecorator(fieldNames.typeId, {
          initialValue: '',
          rules: [
            {
              required: true,
              message: 'Обязательное поле',
            },
          ],
        })(
          <Select
            loading={fieldTypesQuery.isFetching}
            onChange={(fTypeId) => onFieldTypeChange(fTypeId)}
          >
            {Object.values(fieldTypesQuery.data || []).map((fType) => (
              <Select.Option
                key={fType.id}
                value={fType.id}
                searchtext={fType.description}
              >
                {fType.description}
              </Select.Option>
            ))}
          </Select>
        )}
      </Form.Item>
      <Form.Item label="Наименование поля">
        {getFieldDecorator(fieldNames.name, {
          initialValue: '',
          rules: [
            {
              required: true,
              message: 'Обязательное поле',
            },
          ],
        })(<Input />)}
      </Form.Item>
    </Form>
  );
};

AdminInfoCreateFieldForm.propTypes = {
  form: PropTypes.any.isRequired,
};
